<vdr-page-block>
    <vdr-action-bar>
        <vdr-ab-right>
            <vdr-action-bar-items locationId="feedback-list" />
            <a class="btn btn-primary" *vdrIfPermissions="['FeedbackControl']" (click)="downloadFeedbacks()">
                <clr-icon shape="download"></clr-icon>
                Download All Feedbacks
            </a>
        </vdr-ab-right>
    </vdr-action-bar>
    <div *ngIf="isLoading" class="loader-overlay">
        <clr-spinner></clr-spinner>
    </div>
</vdr-page-block>

<vdr-data-table-2
    id="feedback-list"
    [items]="items$ | async"
    [itemsPerPage]="itemsPerPage$ | async"
    [totalItems]="totalItems$ | async"
    [currentPage]="currentPage$ | async"
    [filters]="filters"
    (pageChange)="setPageNumber($event)"
    (itemsPerPageChange)="setItemsPerPage($event)"
    style="display: block; width: 100%; overflow-x: auto; table-layout: fixed"
>
    <vdr-bulk-action-menu
        locationId="feedback-list"
        [hostComponent]="this"
        [selectionManager]="selectionManager"
    />

    <!-- ID (hidden by default) -->
    <vdr-dt2-column
        id="id"
        [heading]="'common.id' | translate"
        [hiddenByDefault]="true"
        [sort]="sorts.get('id')"
    >
        <ng-template let-feedback="item">{{ feedback.id }}</ng-template>
    </vdr-dt2-column>

    <!-- SUBJECT -->
    <vdr-dt2-column
        id="subject"
        heading="subject"
        [sort]="sorts.get('subject')"
        style="
            min-width: 120px;
            max-width: 200px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        "
    >
        <ng-template let-feedback="item">
            <a
                class="button-ghost"
                [routerLink]="['./', feedback.id]"
                style="
                    display: inline-block;
                    max-width: 180px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                "
            >
                <span>{{ feedback.subject }}</span>
                <clr-icon shape="arrow right"></clr-icon>
            </a>
        </ng-template>
    </vdr-dt2-column>

    <!-- MESSAGE -->
    <vdr-dt2-column
        id="message"
        heading="message"
        [sort]="sorts.get('message')"
        style="min-width: 200px; max-width: 300px; word-break: break-word; white-space: normal"
    >
        <ng-template let-feedback="item">
            <div style="white-space: normal; word-break: break-word">
                {{
                    feedback.message.split(' ').length > 80
                        ? feedback.message.split(' ').slice(0, 20).join(' ') + '..........'
                        : feedback.message
                }}
            </div>
        </ng-template>
    </vdr-dt2-column>

    <!-- TYPE -->
    <vdr-dt2-column
        id="type"
        heading="type"
        [sort]="sorts.get('type')"
        style="min-width: 80px; max-width: 120px; white-space: nowrap"
    >
        <ng-template let-feedback="item">{{ feedback.type }}</ng-template>
    </vdr-dt2-column>
    <vdr-dt2-column id="sentiment" heading="sentiment" [sort]="sorts.get('sentiment')">
        <ng-template let-feedback="item">
            {{ feedback.sentiment == 'NA' ? 'N/A' : feedback.sentiment }}
        </ng-template>
    </vdr-dt2-column>

    <!-- TAG -->
    <vdr-dt2-column
        id="tag"
        heading="tag"
        [sort]="sorts.get('tag')"
        style="min-width: 80px; max-width: 120px; white-space: nowrap"
    >
        <ng-template let-feedback="item">{{ feedback.tag }}</ng-template>
    </vdr-dt2-column>

    <!-- CUSTOMER -->
    <vdr-dt2-column
        heading="Customer"
        id="customer"
        [sort]="sorts.get('customerLastName')"
        style="min-width: 140px; max-width: 200px; white-space: nowrap"
    >
        <ng-template let-feedback="item">
            <ng-container *ngIf="feedback.customer; else noCustomer">
                <a
                    class="button-ghost"
                    [routerLink]="['/customer/customers', feedback.customer.id]"
                    target="_blank"
                    style="
                        display: inline-block;
                        max-width: 180px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    "
                >
                    <span>{{ feedback.customer.firstName }} {{ feedback.customer.lastName }}</span>
                    <clr-icon shape="arrow right"></clr-icon>
                </a>
            </ng-container>
            <ng-template #noCustomer>Guest</ng-template>
        </ng-template>
    </vdr-dt2-column>

    <!-- STORE -->
    <vdr-dt2-column
        id="storeName"
        heading="Store Name"
        [sort]="sorts.get('storeName')"
        style="min-width: 100px; max-width: 140px; white-space: nowrap"
    >
        <ng-template let-feedback="item">
            <ng-container *ngIf="feedback.store; else noStoreName">
                <span>{{ feedback.store.code }}</span>
            </ng-container>
            <ng-template #noStoreName>-</ng-template>
        </ng-template>
    </vdr-dt2-column>

    <!-- ORDER -->
    <vdr-dt2-column
        id="orderCode"
        heading="Order Code"
        [sort]="sorts.get('orderCode')"
        style="min-width: 100px; max-width: 140px; white-space: nowrap"
    >
        <ng-template let-feedback="item">
            <ng-container *ngIf="feedback.order; else noOrderCode">
                <a
                    class="button-ghost"
                    [routerLink]="['/orders', feedback.order.id]"
                    target="_blank"
                    style="
                        display: inline-block;
                        max-width: 120px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    "
                >
                    <span>{{ feedback.order.code }}</span>
                    <clr-icon shape="arrow right"></clr-icon>
                </a>
            </ng-container>
            <ng-template #noOrderCode>-</ng-template>
        </ng-template>
    </vdr-dt2-column>

    <!-- DEVICE TYPE -->
    <vdr-dt2-column
        id="deviceType"
        heading="Device Type"
        [sort]="sorts.get('deviceType')"
        style="min-width: 100px; max-width: 140px; white-space: nowrap"
    >
        <ng-template let-feedback="item">
            <ng-container *ngIf="feedback.deviceType; else noDeviceType">
                <span>{{ feedback.deviceType }}</span>
            </ng-container>
            <ng-template #noDeviceType>-</ng-template>
        </ng-template>
    </vdr-dt2-column>

    <!-- CREATED AT (hidden by default) -->
    <vdr-dt2-column
        id="created-at"
        [heading]="'common.created-at' | translate"
        [hiddenByDefault]="true"
        [sort]="sorts.get('createdAt')"
    >
        <ng-template let-feedback="item">{{ feedback.createdAt | localeDate: 'short' }}</ng-template>
    </vdr-dt2-column>

    <!-- UPDATED AT (hidden by default) -->
    <vdr-dt2-column
        id="updated-at"
        [heading]="'common.updated-at' | translate"
        [hiddenByDefault]="true"
        [sort]="sorts.get('updatedAt')"
    >
        <ng-template let-feedback="item">{{ feedback.updatedAt | localeDate: 'short' }}</ng-template>
    </vdr-dt2-column>
</vdr-data-table-2>
